import * as actions from "../constants/actions";
import { actionCreatorsFactory } from "@actionCreator/actionCreatorFactory";

export default actionCreatorsFactory(actions);
